(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const FX = window.RB.FX;

  Object.assign(FX, {
    nameUniverse(kind, type) {
      const seen = {};
      const out = [];
      const db = (typeof window !== "undefined" && window.CARD_DB) || [];
      for (const c of db) {
        if (kind === "tag") {
          for (const t of c.tags || []) if (!seen[t]) { seen[t] = 1; out.push(t); }
          continue;
        }
        if (type && (c.types || []).indexOf(type) < 0) continue;
        if (c.name && !seen[c.name]) { seen[c.name] = 1; out.push(c.name); }
      }
      out.sort();
      return out;
    },

    nameOptions(state, item, op) {
      const seen = {};
      const out = [];
      const who = op.from === "opponent" ? [Core.otherPlayer(item.controller)]
        : op.from === "self" ? [item.controller] : [0, 1];
      for (const iid in state.objs) {
        const o = state.objs[iid];
        if (who.indexOf(o.owner) < 0) continue;
        if (o.zone === "aside") continue;
        if ((op.kind || "tag") === "tag") {
          for (const t of Core.tags(state, iid)) {
            if (!seen[t]) { seen[t] = 1; out.push(t); }
          }
          continue;
        }
        if (op.type && !Core.isType(state, iid, op.type)) continue;
        const nm = Core.name(state, iid);
        if (nm && nm !== "?" && !seen[nm]) { seen[nm] = 1; out.push(nm); }
      }
      out.sort();
      return out;
    },

    chosenBy(item, iid) {
      for (const b in item.targets || {}) {
        if ((item.targets[b] || []).indexOf(iid) >= 0) return true;
      }
      return false;
    },

    replaceEffect(state, item, iid, kind) {
      const o = state.objs[iid];
      if (!o || o.zone !== "board") return false;
      if (!item || (item.kind !== "spell" && item.kind !== "ability")) return false;
      const sc = RB.Scripts.forCard(state, iid);
      const rule = sc && sc.effectReplace;
      if (!rule || (rule.kinds || []).indexOf(kind) < 0) return false;
      if (rule.requiresEmpowered && !o.empowered) return false;
      if (!FX.chosenBy(item, iid)) return false;
      if (rule.grantMight) {
        o.grants.push({ k: "might", value: rule.grantMight, dur: rule.dur || "turn" });
      }
      Core.log(state, Core.name(state, iid) + " is not affected - " +
        (rule.grantMight > 0 ? "it gets +" + rule.grantMight + " Might instead." : "the effect is replaced."), {
        k: "state", p: o.controller, iids: [iid],
      });
      return true;
    },

    lookPlayable(state, item, iid, op, p) {
      if (RB.Play.playRestricted(state, p, iid)) return false;
      if (!RB.Play.requiredTargetsAvailable(state, p, iid, {})) return false;
      const probe = RB.Play.probeItem(state, p, iid, { fromZone: "banish" });
      probe.fromZone = "banish";
      probe.opts = { waive: op.waive || null, energyLess: FX.amount(state, item, op.energyLess || 0) };
      const cost = RB.Play.effectiveCost(state, probe, {});
      return RB.Play.poolPotentialCovers(state, p, cost, RB.Play.payCtxForCard(state, iid));
    },

    stepDeckPeek(state, item, deckOwner, key) {
      if (item.vars[key + "Done"]) return null;
      const peeker = Core.ruleSources(state, "deckRevealPeek")[0];
      if (!peeker) return null;
      const watcher = peeker.iid;
      const top = state.players[deckOwner].mainDeck[0];
      if (!top) return null;
      if (item.vars[key] === undefined) {
        RB.FX.emit(state, {
          type: "revealCards", player: deckOwner, iids: [top], source: "deck", private: true,
          label: Core.name(state, watcher), cardIds: FX.cardIdsOf(state, [top]),
        });
        FX.ask(state, item, key, {
          player: state.objs[watcher].controller, tag: "may", options: ["Yes", "No"],
          prompt: Core.name(state, watcher) + ": the top card is " + Core.name(state, top) + " - recycle it?",
        });
        return "wait";
      }
      item.vars[key + "Done"] = 1;
      if (item.vars[key] === 0) {
        state.players[deckOwner].mainDeck.shift();
        Flow.recycleCards(state, [top]);
        Core.log(state, Core.name(state, watcher) + " recycles the top card before the reveal.", {
          k: "zone", p: deckOwner, iids: [watcher],
        });
      }
      return null;
    },

    runOp(state, item, op) {
      const fn = FX.OPS[op.op];
      if (!fn) throw new Error("unknown op '" + op.op + "' in " + item.label);
      return fn(state, item, op, item.controller, Core.otherPlayer(item.controller));
    },

    cond(state, item, cond) {
      return FX.evalCond(state, cond, { item: item, p: item.controller, iid: item.source, ev: item.ctx && item.ctx.ev });
    },
  });
})();
